import "~/misc/common";
import { p, getUrlParameter, selectObjects, hasMouse } from "~/misc/common";
import L from "~/misc/2d/leaflet";
import { Icon as ExtraIcon, PinCirclePanel } from "leaflet-extra-markers";

import { Controller } from "@hotwired/stimulus";
import { initMapLayered } from "./map_layered";
import { initInfoObjects } from "./info_objects";
import { Context2d, LaunchPlace } from "~/types/map";
import { buildPopup } from "~/misc/2d/builders";

export default class extends Controller {
  connect() {
    console.log('initLaunchPlacesForm');
    const map = initMapLayered();

    initInfoObjects(map);
    initLaunchPlaces(map);

    const launchPlace = map.data.launchPlaces[0];
    const marker = launchPlace.marker;
    const arc = launchPlace.arc || L.marker([0, 0]);
    refresh();

    marker.on('drag', function (e) {
      const latlng = e.target.getLatLng();
      $('.address_lat').val(latlng.lat.toFixed(6));
      $('.address_lon').val(latlng.lng.toFixed(6));
    });
    marker.on('dragend', refresh);
    marker.dragging!.enable();

    $('.address_lat').change(function () {
      const v = $(this).myGetNumValue();
      if (v) {
        marker.setLatLng([v, marker.getLatLng().lng]);
        refresh();
      }
    });

    $('.address_lon').change(function () {
      const v = $(this).myGetNumValue();
      if (v) {
        marker.setLatLng([marker.getLatLng().lat, v]);
        refresh();
      }
    });

    $('#launch_place_degree_min').change(refresh);
    $('#launch_place_degree_max').change(refresh);

    function refresh() {
      launchPlace.degree_min = $('#launch_place_degree_min').myGetNumValue();
      launchPlace.degree_max = $('#launch_place_degree_max').myGetNumValue();
      if (launchPlace.degree_min != null) {
        launchPlace.degree_min = mod(launchPlace.degree_min, 360);
        $('#launch_place_degree_min').val(launchPlace.degree_min);
      }
      if (launchPlace.degree_max != null) {
        launchPlace.degree_max = mod(launchPlace.degree_max, 360);
        $('#launch_place_degree_max').val(launchPlace.degree_max);
      }
      if (launchPlace.degree_min != null && launchPlace.degree_max != null) {
        arc.setLatLng(marker.getLatLng());
        const arcIcon = L.divIcon({
          className: '',
          html: getArcSVG(launchPlace),
          iconSize: [80, 80],
          iconAnchor: [40, 40]
        });
        arc.setIcon(arcIcon);
        arc.addTo(map);
      } else {
        arc.remove();
      }

      marker.remove();
      marker.addTo(map);
      map.myFlyTo(marker.getLatLng(), Math.max(map.getZoom(), 16), {
        duration: 0.5
      });
    }

    function mod(n: number, m: number) {
      return ((n % m) + m) % m;
    }
  }
}

export function initLaunchPlaces(map: Context2d) {
  p('initLaunchPlaces');
  //var featureGroup = L.markerClusterGroup().addTo(map);

  map.createPane('launchPlaces');
  map.getPane('launchPlaces')!.style.zIndex = '501';

  const featureGroup = L.featureGroup().addTo(map);
  const arcFeatureGroup = L.featureGroup().addTo(map);

  map.tree.create_node('launch_areas', {
    id: 'launch_places',
    icon: 'fa fa-map-marker',
    text: "Starthelyek"
  }, 'first');
  map.tree.create_node('launch_areas', {
    id: 'degrees',
    icon: 'bi-pie-chart-fill',
    text: "Startszögek"
  });

  map.tree.element.on("check_node.jstree uncheck_node.jstree state_ready.jstree", refreshLayers);
  function refreshLayers() {
    featureGroup.remove();
    arcFeatureGroup.remove();
    map.tree.is_checked('degrees') ? arcFeatureGroup.addTo(map) : null;
    map.tree.is_checked('launch_places') ? featureGroup.addTo(map) : null;
  }

  for (const launchPlace of map.data.launchPlaces) {
    //if (launchPlace.id != 50) {
    //	return;
    //}

    // POPUP
    launchPlace.openPopup = function () {
      openPopupInner(launchPlace);
    };

    if (launchPlace.degree_min != null) {
      const arcIcon = L.divIcon({
        className: '',
        html: getArcSVG(launchPlace),
        iconSize: [80, 80],
        iconAnchor: [40, 40]
      });
      const arc = L.marker([launchPlace.lat, launchPlace.lon],
        {
          icon: arcIcon, interactive: false,
          pane: 'launchPlaces'
        }).addTo(arcFeatureGroup);
      launchPlace.arc = arc;
      //if (hasMouse()) {
      //	arc.bindTooltip(launchPlace.name);
      //}
      //arc.on('click', function (e) {
      //	launchPlace.openPopup();
      //});
    }

    let type = selectObjects(map.data.launchPlaceTypes, 'id', launchPlace.launch_place_type_id)[0];
    type ||= { icon: "= fa_icon 'circle'", id: 0, name: '' };
    const match = type.icon.match(/^=\s*(\w+)_icon\s+'([^']+)'/) ?? [];
    const [_, prefix, iconName] = match;
    let status = selectObjects(map.data.launchPlaceStatuses, 'id', launchPlace.launch_place_status_id)[0];
    status ||= { color: 'grey', id: 0, name: '' };
    var icon = new ExtraIcon({
      contentHtml: `<i class="${prefix} ${prefix}-${iconName}"></i>`,
      color: status.color,
      svg: PinCirclePanel
    });
    launchPlace.lat ||= map.getCenter().lat;
    launchPlace.lon ||= map.getCenter().lng;
    var marker = L.marker([launchPlace.lat, launchPlace.lon], {
      icon: icon,
      pane: 'launchPlaces'
    }).addTo(featureGroup);
    launchPlace.marker = marker;
    if (hasMouse()) {
      marker.bindTooltip(launchPlace.name || 'Új starthely');
    }
    marker.on('click', function (e) {
      launchPlace.openPopup();
    });

    map.launchAreas[launchPlace.launch_area_id] ||= L.featureGroup();
    marker.addTo(map.launchAreas[launchPlace.launch_area_id]);

  };

  const url_id = getUrlParameter('launch_place_id');
  if (url_id && typeof url_id === 'string') {
    const launchPlace = selectObjects(map.data.launchPlaces, 'id', parseInt(url_id))[0];
    map.myFlyTo(launchPlace.marker.getLatLng(), Math.max(map.getZoom(), 16), {
      duration: 0.5
    });
    setTimeout(function () {
      launchPlace.openPopup();
    }, 505);
  }

  function openPopupInner(launchPlace: LaunchPlace) {
    if (launchPlace.id) {
      const locale = $('meta[name="locale"]').attr('content') || 'hu';
      $.get(`/${locale}/launch_places/${launchPlace.id}/details`, function (html) {
        L.popup().setLatLng([launchPlace.lat, launchPlace.lon])
          .setContent(createPopup(launchPlace, html)).openOn(map);
      });
    }
  }

  function createPopup(launchPlace: LaunchPlace, content: string) {
    const type = selectObjects(map.data.launchPlaceTypes, 'id', launchPlace.launch_place_type_id)[0];
    const match = type.icon.match(/^=\s*(\w+)_icon\s+'([^']+)'/) ?? [];
    const [_, prefix, iconName] = match;
    const status = selectObjects(map.data.launchPlaceStatuses, 'id', launchPlace.launch_place_status_id)[0];

    const icon = `<i class="${prefix} ${prefix}-${iconName}" style="color: ${status.color};"></i>`;
    const title = icon + ' ' + launchPlace.name;

    return buildPopup(title, content);
  }
}

function getArcPath(r: number, min: number, max: number) {
  let path = "M 0,0 ";
  //path += Math.sin(min * Math.PI / 180.0) * r + "," + -Math.cos(min * Math.PI / 180.0) * r + ' ';
  //if (!min < max) min -= 360;
  for (let d = min; d < max; d += 5) {
    path += Math.sin(d * Math.PI / 180.0) * r + "," + -Math.cos(d * Math.PI / 180.0) * r + ' ';
  }
  path += Math.sin(max * Math.PI / 180.0) * r + "," + -Math.cos(max * Math.PI / 180.0) * r + ' ';
  path += "z";
  return path;
}

function getArcSVG(data: LaunchPlace) {
  const r = 40;
  const min = data.degree_min! < data.degree_max! ? data.degree_min! : data.degree_min! - 360;
  const path = getArcPath(r, min, data.degree_max!);
  // Calculate full SVG size
  const size = r * 2;

  // Return full SVG string for use in Leaflet divIcon
  return `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="${-r} ${-r} ${size} ${size}">
      <path d="${path}" fill="#3fad46" fill-opacity="0.8" stroke="white" stroke-width="1"/>
    </svg>
  `;
}

